//======================Centralized API Headers============================================
import axios from "axios";
import { toast } from "react-toastify";

axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('authToken');
  

    if (token) {
      config.headers["Authorization"] = token;
    }
      
    return config;
  },
  (error) => {
    return Promise.reject(error); // Handle any errors
  }

);

axios.interceptors.response.use(
  (response) => {
    if (response.data === 'UNAUTHORIZED') {
        sessionStorage.clear();
        window.location.href = '/';
        toast.warn("Session expired !! Please login again");
    }
    
    return response;  // Return the response if no error
  });



//==========================================================

// export const BaseIP = "http://192.168.29.102:8080/sdsd/"    //===========Common IP with VAR name (ONLINE)
// export const BaseIP = "http://192.168.29.102:8080"    //===========Common IP for build (ONLINE)
// export const BaseIPForPDF = "http://192.168.29.102:8080"    //===========Common IP for PDF(ONLINE)

export const BaseIPForPDF = "https://server2.purnaacademic.in:8443/"    //===========Common IP for PDF(BUILD)
export const BaseIP = "https://server2.purnaacademic.in:8443/AluSmartERP/"    //===========Common IP(BUILD)

// export const BaseIPForPDF = "http://192.168.29.112:8090/"    //===========Common IP for PDF(OFFLINE)
// export const BaseIP = "http://192.168.29.112:8182/"    //===========Common IP(OFFLINE)

export const LoginApi = BaseIP + "auth/login/userLogin"    //===========(Params => ?loginId=user&password=123)
